import { FeaturesStep4Form } from './features-step4-form';
import { InputText } from '../../../classes/input-text';
import { InputBase } from '../../../classes/input-base';

export class FeaturesStep4FormFacebookAds extends FeaturesStep4Form {
	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Url',
		buttonSymbol: 'Go',
		required: true,
		blur: true,
	});

	bookPriceDuringPromo = new InputText({
		key: 'bookPriceDuringPromo',
		label: 'Book Price During Promotion',
		required: true,
		type: 'number',
		addonSymbol: '$',
		tooltipText: 'If your book will be multiple prices over the course of your promotion, '
      + 'then please enter the lowest price here. Our team will follow up with you to and ask you for all '
      + 'the information on your price during the promotion. ',
		tooltip: '?',
		min: 0,
	});

	kindleUnlimited = new InputBase({
		key: 'kindleUnlimited',
		label: 'Is your book enrolled in Kindle Unlimited?',
		controlType: 'checkbox',
	});

	kindleCountdownDeal = new InputBase({
		key: 'kindleCountdownDeal',
		label: 'Is this a Kindle Countdown Deal?',
		controlType: 'checkbox',
	});
}
